import React from 'react'

function Style2Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="67" height="21" viewBox="0 0 67 21"><defs>
        
        </defs>
        <g transform="translate(-212 -709)">
        <g class="a" fill="#fff" stroke="#acacac" transform="translate(212 715)">
        <rect class="d" stroke="none" width="67" height="15" rx="2"/>
        <rect class="e" fill="none" x="0.5" y="0.5" width="66" height="14" rx="1.5"/>
        </g>
        <rect class="b" fill="#fff" width="26" height="10" transform="translate(216 711)"/>
        <text class="c" fill="#7c7c7c" fontSize="8px" fontFamily="OpenSans-Bold, Open Sans" fontWeight="700" transform="translate(219 718)">
        <tspan x="0" y="0">xxxx</tspan>
        </text></g></svg>
    )
}

export default Style2Icon
